import { AppConfig } from '@aipb/env/util';
import { FulltextCastorEnv, FulltextEnv, FulltextTranslationEnv } from './fulltext.env';

export class FulltextConfig extends AppConfig<FulltextEnv> {
  get highlightingFragsize(): number {
    return this.config.highlightingFragsize || 50;
  }

  get apiUrl(): string {
    // @ts-expect-error foo
    return this.config.apiUrl;
  }

  get facetLimit(): number {
    return this.config.facetLimit || 100;
  }

  get castor(): FulltextCastorEnv {
    // @ts-expect-error foo
    return this.config.castor;
  }

  get authenticationRoles(): string[] {
    return this.config.authenticationRoles || [];
  }

  get cs(): FulltextTranslationEnv {
    // @ts-expect-error foo
    return this.config.cs;
  }

  get en(): FulltextTranslationEnv {
    // @ts-expect-error foo
    return this.config.en;
  }

  get fragmentLimits(): { [key: string]: number } {
    return this.config.fragmentLimits || {};
  }
}
